import React from 'react'
import useStyles from '../styles'

interface LogSkeletonProps {
  rows: number
  gridTemplateColumns: string
  columnCount: number
}

const COLUMN_BAR_WIDTHS = [75, 55, 70, 60, 65, 60]
const MESSAGE_BAR_WIDTHS = [85, 55, 70, 40, 90, 60, 75, 45]

const LogSkeleton: React.FC<LogSkeletonProps> = ({
  rows,
  gridTemplateColumns,
  columnCount,
}) => {
  const classes = useStyles()

  return (
    <div
      className={classes.logList}
      aria-hidden='true'
    >
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div
          key={rowIndex}
          className={`${classes.logGrid} ${classes.skeletonRow}`}
          style={{ gridTemplateColumns }}
        >
          {Array.from({ length: columnCount }, (_, colIndex) => {
            const isMessageColumn = colIndex === columnCount - 1
            const width = isMessageColumn
              ? MESSAGE_BAR_WIDTHS[rowIndex % MESSAGE_BAR_WIDTHS.length]
              : COLUMN_BAR_WIDTHS[colIndex % COLUMN_BAR_WIDTHS.length]
            return (
              <div key={colIndex}>
                <div
                  className={classes.skeletonBar}
                  style={{ width: `${width}%` }}
                />
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default LogSkeleton
